module.exports = __webpack_public_path__ + "static/media/Conga_Wordmark_Purple400Small.334bc145.svg";